export const arrayMove = (arr: any[], old_index: number, new_index: number) => {
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
};
export class ExpandedCollapsed {
    all: 'expanded' | 'collapsed' | 'unset';
    constructor(data: any = {}) {
        this.all = data.all;
        Object.keys(data).map((k) => (this[k] = data[k]));
    }
    getValue(k: string) {
        if (k === 'all') {
            if (this.all === 'unset') {
                return this.all;
            }
            return Object.keys(this)
                .filter((k) => k !== 'getValue' && k !== '_getValue' && k !== 'all')
                .find((k) => this[k] !== this.all)
                ? 'unset'
                : this.all;
        }
        return this[k] || this.all;
    }
    [key: string]: 'expanded' | 'collapsed' | 'unset' | any;
}
